var _excluded = ["isGhost"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _Symbol$for, _Symbol$for2;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
/* eslint-disable max-classes-per-file */

/* global AggregateError */


import Translator from '@uppy/utils/lib/Translator';
import ee from 'namespace-emitter';
import { nanoid } from 'nanoid/non-secure';
import throttle from 'lodash.throttle';
import DefaultStore from '@uppy/store-default';
import getFileType from '@uppy/utils/lib/getFileType';
import getFileNameAndExtension from '@uppy/utils/lib/getFileNameAndExtension';
import { getSafeFileId } from '@uppy/utils/lib/generateFileID';
import supportsUploadProgress from './supportsUploadProgress.js';
import getFileName from './getFileName.js';
import { justErrorsLogger, debugLogger } from './loggers.js';
import { Restricter, defaultOptions as defaultRestrictionOptions, RestrictionError } from './Restricter.js';
var packageJson = {
  "version": "3.2.0"
};
import locale from './locale.js';
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */

var _plugins = /*#__PURE__*/_classPrivateFieldLooseKey("plugins");

var _restricter = /*#__PURE__*/_classPrivateFieldLooseKey("restricter");

var _storeUnsubscribe = /*#__PURE__*/_classPrivateFieldLooseKey("storeUnsubscribe");

var _emitter = /*#__PURE__*/_classPrivateFieldLooseKey("emitter");

var _preProcessors = /*#__PURE__*/_classPrivateFieldLooseKey("preProcessors");

var _uploaders = /*#__PURE__*/_classPrivateFieldLooseKey("uploaders");

var _postProcessors = /*#__PURE__*/_classPrivateFieldLooseKey("postProcessors");

var _informAndEmit = /*#__PURE__*/_classPrivateFieldLooseKey("informAndEmit");

var _checkRequiredMetaFieldsOnFile = /*#__PURE__*/_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");

var _checkRequiredMetaFields = /*#__PURE__*/_classPrivateFieldLooseKey("checkRequiredMetaFields");

var _assertNewUploadAllowed = /*#__PURE__*/_classPrivateFieldLooseKey("assertNewUploadAllowed");

var _transformFile = /*#__PURE__*/_classPrivateFieldLooseKey("transformFile");

var _startIfAutoProceed = /*#__PURE__*/_classPrivateFieldLooseKey("startIfAutoProceed");

var _checkAndUpdateFileState = /*#__PURE__*/_classPrivateFieldLooseKey("checkAndUpdateFileState");

var _addListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addListeners");

var _updateOnlineStatus = /*#__PURE__*/_classPrivateFieldLooseKey("updateOnlineStatus");

var _createUpload = /*#__PURE__*/_classPrivateFieldLooseKey("createUpload");

var _getUpload = /*#__PURE__*/_classPrivateFieldLooseKey("getUpload");

var _removeUpload = /*#__PURE__*/_classPrivateFieldLooseKey("removeUpload");

var _runUpload = /*#__PURE__*/_classPrivateFieldLooseKey("runUpload");

_Symbol$for = Symbol.for('uppy test: getPlugins');
_Symbol$for2 = Symbol.for('uppy test: createUpload');

var Uppy = /*#__PURE__*/function (_Symbol$for3, _Symbol$for4) {
  /** @type {Record<string, BasePlugin[]>} */

  /**
   * Instantiate Uppy
   *
   * @param {object} opts — Uppy options
   */
  function Uppy(_opts) {
    var _this = this;

    _classCallCheck(this, Uppy);

    Object.defineProperty(this, _runUpload, {
      value: _runUpload2
    });
    Object.defineProperty(this, _removeUpload, {
      value: _removeUpload2
    });
    Object.defineProperty(this, _getUpload, {
      value: _getUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    Object.defineProperty(this, _addListeners, {
      value: _addListeners2
    });
    Object.defineProperty(this, _checkAndUpdateFileState, {
      value: _checkAndUpdateFileState2
    });
    Object.defineProperty(this, _startIfAutoProceed, {
      value: _startIfAutoProceed2
    });
    Object.defineProperty(this, _transformFile, {
      value: _transformFile2
    });
    Object.defineProperty(this, _assertNewUploadAllowed, {
      value: _assertNewUploadAllowed2
    });
    Object.defineProperty(this, _checkRequiredMetaFields, {
      value: _checkRequiredMetaFields2
    });
    Object.defineProperty(this, _checkRequiredMetaFieldsOnFile, {
      value: _checkRequiredMetaFieldsOnFile2
    });
    Object.defineProperty(this, _informAndEmit, {
      value: _informAndEmit2
    });
    Object.defineProperty(this, _plugins, {
      writable: true,
      value: Object.create(null)
    });
    Object.defineProperty(this, _restricter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _storeUnsubscribe, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: ee()
    });
    Object.defineProperty(this, _preProcessors, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _uploaders, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _postProcessors, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _updateOnlineStatus, {
      writable: true,
      value: this.updateOnlineStatus.bind(this)
    });
    this.defaultLocale = locale;
    var defaultOptions = {
      id: 'uppy',
      autoProceed: false,
      allowMultipleUploadBatches: true,
      debug: false,
      restrictions: defaultRestrictionOptions,
      meta: {},
      onBeforeFileAdded: function onBeforeFileAdded(currentFile) {
        return currentFile;
      },
      onBeforeUpload: function onBeforeUpload(files) {
        return files;
      },
      store: new DefaultStore(),
      logger: justErrorsLogger,
      infoTimeout: 5000
    }; // Merge default options with the ones set by user,
    // making sure to merge restrictions too

    this.opts = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), _opts), {}, {
      restrictions: _objectSpread(_objectSpread({}, defaultOptions.restrictions), _opts && _opts.restrictions)
    }); // Support debug: true for backwards-compatability, unless logger is set in opts
    // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions

    if (_opts && _opts.logger && _opts.debug) {
      this.log('You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.', 'warning');
    } else if (_opts && _opts.debug) {
      this.opts.logger = debugLogger;
    }

    this.log("Using Core v".concat(this.constructor.VERSION));
    this.i18nInit(); // ___Why throttle at 500ms?
    //    - We must throttle at >250ms for superfocus in Dashboard to work well
    //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
    //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
    //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
    //    - We must throttle at around >500ms to avoid performance lags.
    //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.

    this.calculateProgress = throttle(this.calculateProgress.bind(this), 500, {
      leading: true,
      trailing: true
    });
    this.store = this.opts.store;
    this.setState({
      plugins: {},
      files: {},
      currentUploads: {},
      allowNewUpload: true,
      capabilities: {
        uploadProgress: supportsUploadProgress(),
        individualCancellation: true,
        resumableUploads: false
      },
      totalProgress: 0,
      meta: _objectSpread({}, this.opts.meta),
      info: [],
      recoveredState: null
    });
    _classPrivateFieldLooseBase(this, _restricter)[_restricter] = new Restricter(function () {
      return _this.opts;
    }, this.i18n);
    _classPrivateFieldLooseBase(this, _storeUnsubscribe)[_storeUnsubscribe] = this.store.subscribe(function (prevState, nextState, patch) {
      _this.emit('state-update', prevState, nextState, patch);

      _this.updateAll(nextState);
    }); // Exposing uppy object on window for debugging and testing

    if (this.opts.debug && typeof window !== 'undefined') {
      window[this.opts.id] = this;
    }

    _classPrivateFieldLooseBase(this, _addListeners)[_addListeners]();
  }

  _createClass(Uppy, [{
    key: "emit",
    value: function emit(event) {
      var _classPrivateFieldLoo2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _emitter)[_emitter]).emit.apply(_classPrivateFieldLoo2, [event].concat(args));
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].on(event, callback);

      return this;
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].once(event, callback);

      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].off(event, callback);

      return this;
    }
    /**
     * Iterate on all plugins and run `update` on them.
     * Called each time state changes.
     *
     */

  }, {
    key: "updateAll",
    value: function updateAll(state) {
      this.iteratePlugins(function (plugin) {
        plugin.update(state);
      });
    }
    /**
     * Updates state with a patch
     *
     * @param {object} patch {foo: 'bar'}
     */

  }, {
    key: "setState",
    value: function setState(patch) {
      this.store.setState(patch);
    }
    /**
     * Returns current state.
     *
     * @returns {object}
     */

  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    }
  }, {
    key: "patchFilesState",
    value: function patchFilesState(filesWithNewState) {
      var existingFilesState = this.getState().files;
      this.setState({
        files: _objectSpread(_objectSpread({}, existingFilesState), Object.fromEntries(Object.entries(filesWithNewState).map(function (_ref) {
          var _ref4 = _slicedToArray(_ref, 2),
              fileID = _ref4[0],
              newFileState = _ref4[1];

          return [fileID, _objectSpread(_objectSpread({}, existingFilesState[fileID]), newFileState)];
        })))
      });
    }
    /**
     * Shorthand to set state for a specific file.
     */

  }, {
    key: "setFileState",
    value: function setFileState(fileID, state) {
      if (!this.getState().files[fileID]) {
        throw new Error("Can\u2019t set state for ".concat(fileID, " (the file could have been removed)"));
      }

      this.patchFilesState(_defineProperty({}, fileID, state));
    }
  }, {
    key: "i18nInit",
    value: function i18nInit() {
      var translator = new Translator([this.defaultLocale, this.opts.locale]);
      this.i18n = translator.translate.bind(translator);
      this.i18nArray = translator.translateArray.bind(translator);
      this.locale = translator.locale;
    }
  }, {
    key: "setOptions",
    value: function setOptions(newOpts) {
      this.opts = _objectSpread(_objectSpread(_objectSpread({}, this.opts), newOpts), {}, {
        restrictions: _objectSpread(_objectSpread({}, this.opts.restrictions), newOpts && newOpts.restrictions)
      });

      if (newOpts.meta) {
        this.setMeta(newOpts.meta);
      }

      this.i18nInit();

      if (newOpts.locale) {
        this.iteratePlugins(function (plugin) {
          plugin.setOptions(newOpts);
        });
      } // Note: this is not the preact `setState`, it's an internal function that has the same name.


      this.setState(); // so that UI re-renders with new options
    }
  }, {
    key: "resetProgress",
    value: function resetProgress() {
      var defaultProgress = {
        percentage: 0,
        bytesUploaded: 0,
        uploadComplete: false,
        uploadStarted: null
      };

      var files = _objectSpread({}, this.getState().files);

      var updatedFiles = {};
      Object.keys(files).forEach(function (fileID) {
        updatedFiles[fileID] = _objectSpread(_objectSpread({}, files[fileID]), {}, {
          progress: _objectSpread(_objectSpread({}, files[fileID].progress), defaultProgress)
        });
      });
      this.setState({
        files: updatedFiles,
        totalProgress: 0,
        allowNewUpload: true,
        error: null,
        recoveredState: null
      });
      this.emit('reset-progress');
    }
  }, {
    key: "addPreProcessor",
    value: function addPreProcessor(fn) {
      _classPrivateFieldLooseBase(this, _preProcessors)[_preProcessors].add(fn);
    }
  }, {
    key: "removePreProcessor",
    value: function removePreProcessor(fn) {
      return _classPrivateFieldLooseBase(this, _preProcessors)[_preProcessors].delete(fn);
    }
  }, {
    key: "addPostProcessor",
    value: function addPostProcessor(fn) {
      _classPrivateFieldLooseBase(this, _postProcessors)[_postProcessors].add(fn);
    }
  }, {
    key: "removePostProcessor",
    value: function removePostProcessor(fn) {
      return _classPrivateFieldLooseBase(this, _postProcessors)[_postProcessors].delete(fn);
    }
  }, {
    key: "addUploader",
    value: function addUploader(fn) {
      _classPrivateFieldLooseBase(this, _uploaders)[_uploaders].add(fn);
    }
  }, {
    key: "removeUploader",
    value: function removeUploader(fn) {
      return _classPrivateFieldLooseBase(this, _uploaders)[_uploaders].delete(fn);
    }
  }, {
    key: "setMeta",
    value: function setMeta(data) {
      var updatedMeta = _objectSpread(_objectSpread({}, this.getState().meta), data);

      var updatedFiles = _objectSpread({}, this.getState().files);

      Object.keys(updatedFiles).forEach(function (fileID) {
        updatedFiles[fileID] = _objectSpread(_objectSpread({}, updatedFiles[fileID]), {}, {
          meta: _objectSpread(_objectSpread({}, updatedFiles[fileID].meta), data)
        });
      });
      this.log('Adding metadata:');
      this.log(data);
      this.setState({
        meta: updatedMeta,
        files: updatedFiles
      });
    }
  }, {
    key: "setFileMeta",
    value: function setFileMeta(fileID, data) {
      var updatedFiles = _objectSpread({}, this.getState().files);

      if (!updatedFiles[fileID]) {
        this.log('Was trying to set metadata for a file that has been removed: ', fileID);
        return;
      }

      var newMeta = _objectSpread(_objectSpread({}, updatedFiles[fileID].meta), data);

      updatedFiles[fileID] = _objectSpread(_objectSpread({}, updatedFiles[fileID]), {}, {
        meta: newMeta
      });
      this.setState({
        files: updatedFiles
      });
    }
    /**
     * Get a file object.
     *
     * @param {string} fileID The ID of the file object to return.
     */

  }, {
    key: "getFile",
    value: function getFile(fileID) {
      return this.getState().files[fileID];
    }
    /**
     * Get all files in an array.
     */

  }, {
    key: "getFiles",
    value: function getFiles() {
      var _this$getState = this.getState(),
          files = _this$getState.files;

      return Object.values(files);
    }
  }, {
    key: "getFilesByIds",
    value: function getFilesByIds(ids) {
      var _this2 = this;

      return ids.map(function (id) {
        return _this2.getFile(id);
      });
    }
  }, {
    key: "getObjectOfFilesPerState",
    value: function getObjectOfFilesPerState() {
      var _this$getState2 = this.getState(),
          filesObject = _this$getState2.files,
          totalProgress = _this$getState2.totalProgress,
          error = _this$getState2.error;

      var files = Object.values(filesObject);
      var inProgressFiles = files.filter(function (_ref2) {
        var progress = _ref2.progress;
        return !progress.uploadComplete && progress.uploadStarted;
      });
      var newFiles = files.filter(function (file) {
        return !file.progress.uploadStarted;
      });
      var startedFiles = files.filter(function (file) {
        return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
      });
      var uploadStartedFiles = files.filter(function (file) {
        return file.progress.uploadStarted;
      });
      var pausedFiles = files.filter(function (file) {
        return file.isPaused;
      });
      var completeFiles = files.filter(function (file) {
        return file.progress.uploadComplete;
      });
      var erroredFiles = files.filter(function (file) {
        return file.error;
      });
      var inProgressNotPausedFiles = inProgressFiles.filter(function (file) {
        return !file.isPaused;
      });
      var processingFiles = files.filter(function (file) {
        return file.progress.preprocess || file.progress.postprocess;
      });
      return {
        newFiles: newFiles,
        startedFiles: startedFiles,
        uploadStartedFiles: uploadStartedFiles,
        pausedFiles: pausedFiles,
        completeFiles: completeFiles,
        erroredFiles: erroredFiles,
        inProgressFiles: inProgressFiles,
        inProgressNotPausedFiles: inProgressNotPausedFiles,
        processingFiles: processingFiles,
        isUploadStarted: uploadStartedFiles.length > 0,
        isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
        isAllErrored: !!error && erroredFiles.length === files.length,
        isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
        isUploadInProgress: inProgressFiles.length > 0,
        isSomeGhost: files.some(function (file) {
          return file.isGhost;
        })
      };
    }
    /*
    * @constructs
    * @param { Error[] } errors
    * @param { undefined } file
    */

    /*
    * @constructs
    * @param { RestrictionError } error
    */

  }, {
    key: "validateRestrictions",
    value: function validateRestrictions(file, files) {
      if (files === void 0) {
        files = this.getFiles();
      }

      try {
        _classPrivateFieldLooseBase(this, _restricter)[_restricter].validate(files, [file]);
      } catch (err) {
        return err;
      }

      return null;
    }
  }, {
    key: "checkIfFileAlreadyExists",
    value: function checkIfFileAlreadyExists(fileID) {
      var _this$getState3 = this.getState(),
          files = _this$getState3.files;

      if (files[fileID] && !files[fileID].isGhost) {
        return true;
      }

      return false;
    }
    /**
     * Create a file state object based on user-provided `addFile()` options.
     */

    /**
     * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
     * try to guess file type in a clever way, check file against restrictions,
     * and start an upload if `autoProceed === true`.
     *
     * @param {object} file object to add
     * @returns {string} id for the added file
     */

  }, {
    key: "addFile",
    value: function addFile(file) {
      _classPrivateFieldLooseBase(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](file);

      var _classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _checkAndUpdateFileState)[_checkAndUpdateFileState]([file]),
          nextFilesState = _classPrivateFieldLoo3.nextFilesState,
          validFilesToAdd = _classPrivateFieldLoo3.validFilesToAdd,
          errors = _classPrivateFieldLoo3.errors;

      var restrictionErrors = errors.filter(function (error) {
        return error.isRestriction;
      });

      _classPrivateFieldLooseBase(this, _informAndEmit)[_informAndEmit](restrictionErrors);

      if (errors.length > 0) throw errors[0];
      this.setState({
        files: nextFilesState
      });

      var _validFilesToAdd = _slicedToArray(validFilesToAdd, 1),
          firstValidFileToAdd = _validFilesToAdd[0];

      this.emit('file-added', firstValidFileToAdd);
      this.emit('files-added', validFilesToAdd);
      this.log("Added file: ".concat(firstValidFileToAdd.name, ", ").concat(firstValidFileToAdd.id, ", mime type: ").concat(firstValidFileToAdd.type));

      _classPrivateFieldLooseBase(this, _startIfAutoProceed)[_startIfAutoProceed]();

      return firstValidFileToAdd.id;
    }
    /**
     * Add multiple files to `state.files`. See the `addFile()` documentation.
     *
     * If an error occurs while adding a file, it is logged and the user is notified.
     * This is good for UI plugins, but not for programmatic use.
     * Programmatic users should usually still use `addFile()` on individual files.
     */

  }, {
    key: "addFiles",
    value: function addFiles(fileDescriptors) {
      var _this3 = this;

      _classPrivateFieldLooseBase(this, _assertNewUploadAllowed)[_assertNewUploadAllowed]();

      var _classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _checkAndUpdateFileState)[_checkAndUpdateFileState](fileDescriptors),
          nextFilesState = _classPrivateFieldLoo4.nextFilesState,
          validFilesToAdd = _classPrivateFieldLoo4.validFilesToAdd,
          errors = _classPrivateFieldLoo4.errors;

      var restrictionErrors = errors.filter(function (error) {
        return error.isRestriction;
      });

      _classPrivateFieldLooseBase(this, _informAndEmit)[_informAndEmit](restrictionErrors);

      var nonRestrictionErrors = errors.filter(function (error) {
        return !error.isRestriction;
      });

      if (nonRestrictionErrors.length > 0) {
        var message = 'Multiple errors occurred while adding files:\n';
        nonRestrictionErrors.forEach(function (subError) {
          message += "\n * ".concat(subError.message);
        });
        this.info({
          message: this.i18n('addBulkFilesFailed', {
            smart_count: nonRestrictionErrors.length
          }),
          details: message
        }, 'error', this.opts.infoTimeout);

        if (typeof AggregateError === 'function') {
          throw new AggregateError(nonRestrictionErrors, message);
        } else {
          var err = new Error(message);
          err.errors = nonRestrictionErrors;
          throw err;
        }
      } // OK, we haven't thrown an error, we can start updating state and emitting events now:


      this.setState({
        files: nextFilesState
      });
      validFilesToAdd.forEach(function (file) {
        _this3.emit('file-added', file);
      });
      this.emit('files-added', validFilesToAdd);

      if (validFilesToAdd.length > 5) {
        this.log("Added batch of ".concat(validFilesToAdd.length, " files"));
      } else {
        Object.values(validFilesToAdd).forEach(function (file) {
          _this3.log("Added file: ".concat(file.name, "\n id: ").concat(file.id, "\n type: ").concat(file.type));
        });
      }

      if (validFilesToAdd.length > 0) {
        _classPrivateFieldLooseBase(this, _startIfAutoProceed)[_startIfAutoProceed]();
      }
    }
  }, {
    key: "removeFiles",
    value: function removeFiles(fileIDs, reason) {
      var _this4 = this;

      var _this$getState4 = this.getState(),
          files = _this$getState4.files,
          currentUploads = _this$getState4.currentUploads;

      var updatedFiles = _objectSpread({}, files);

      var updatedUploads = _objectSpread({}, currentUploads);

      var removedFiles = Object.create(null);
      fileIDs.forEach(function (fileID) {
        if (files[fileID]) {
          removedFiles[fileID] = files[fileID];
          delete updatedFiles[fileID];
        }
      }); // Remove files from the `fileIDs` list in each upload.

      function fileIsNotRemoved(uploadFileID) {
        return removedFiles[uploadFileID] === undefined;
      }

      Object.keys(updatedUploads).forEach(function (uploadID) {
        var newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved); // Remove the upload if no files are associated with it anymore.

        if (newFileIDs.length === 0) {
          delete updatedUploads[uploadID];
          return;
        }

        var _this4$getState = _this4.getState(),
            capabilities = _this4$getState.capabilities;

        if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) {
          throw new Error('individualCancellation is disabled');
        }

        updatedUploads[uploadID] = _objectSpread(_objectSpread({}, currentUploads[uploadID]), {}, {
          fileIDs: newFileIDs
        });
      });
      var stateUpdate = {
        currentUploads: updatedUploads,
        files: updatedFiles
      }; // If all files were removed - allow new uploads,
      // and clear recoveredState

      if (Object.keys(updatedFiles).length === 0) {
        stateUpdate.allowNewUpload = true;
        stateUpdate.error = null;
        stateUpdate.recoveredState = null;
      }

      this.setState(stateUpdate);
      this.calculateTotalProgress();
      var removedFileIDs = Object.keys(removedFiles);
      removedFileIDs.forEach(function (fileID) {
        _this4.emit('file-removed', removedFiles[fileID], reason);
      });

      if (removedFileIDs.length > 5) {
        this.log("Removed ".concat(removedFileIDs.length, " files"));
      } else {
        this.log("Removed files: ".concat(removedFileIDs.join(', ')));
      }
    }
  }, {
    key: "removeFile",
    value: function removeFile(fileID, reason) {
      if (reason === void 0) {
        reason = null;
      }

      this.removeFiles([fileID], reason);
    }
  }, {
    key: "pauseResume",
    value: function pauseResume(fileID) {
      if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).uploadComplete) {
        return undefined;
      }

      var wasPaused = this.getFile(fileID).isPaused || false;
      var isPaused = !wasPaused;
      this.setFileState(fileID, {
        isPaused: isPaused
      });
      this.emit('upload-pause', fileID, isPaused);
      return isPaused;
    }
  }, {
    key: "pauseAll",
    value: function pauseAll() {
      var updatedFiles = _objectSpread({}, this.getState().files);

      var inProgressUpdatedFiles = Object.keys(updatedFiles).filter(function (file) {
        return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
      });
      inProgressUpdatedFiles.forEach(function (file) {
        var updatedFile = _objectSpread(_objectSpread({}, updatedFiles[file]), {}, {
          isPaused: true
        });

        updatedFiles[file] = updatedFile;
      });
      this.setState({
        files: updatedFiles
      });
      this.emit('pause-all');
    }
  }, {
    key: "resumeAll",
    value: function resumeAll() {
      var updatedFiles = _objectSpread({}, this.getState().files);

      var inProgressUpdatedFiles = Object.keys(updatedFiles).filter(function (file) {
        return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
      });
      inProgressUpdatedFiles.forEach(function (file) {
        var updatedFile = _objectSpread(_objectSpread({}, updatedFiles[file]), {}, {
          isPaused: false,
          error: null
        });

        updatedFiles[file] = updatedFile;
      });
      this.setState({
        files: updatedFiles
      });
      this.emit('resume-all');
    }
  }, {
    key: "retryAll",
    value: function retryAll() {
      var updatedFiles = _objectSpread({}, this.getState().files);

      var filesToRetry = Object.keys(updatedFiles).filter(function (file) {
        return updatedFiles[file].error;
      });
      filesToRetry.forEach(function (file) {
        var updatedFile = _objectSpread(_objectSpread({}, updatedFiles[file]), {}, {
          isPaused: false,
          error: null
        });

        updatedFiles[file] = updatedFile;
      });
      this.setState({
        files: updatedFiles,
        error: null
      });
      this.emit('retry-all', filesToRetry);

      if (filesToRetry.length === 0) {
        return Promise.resolve({
          successful: [],
          failed: []
        });
      }

      var uploadID = _classPrivateFieldLooseBase(this, _createUpload)[_createUpload](filesToRetry, {
        forceAllowNewUpload: true // create new upload even if allowNewUpload: false

      });

      return _classPrivateFieldLooseBase(this, _runUpload)[_runUpload](uploadID);
    }
  }, {
    key: "cancelAll",
    value: function cancelAll(_temp) {
      var _ref5 = _temp === void 0 ? {} : _temp,
          _ref5$reason = _ref5.reason,
          reason = _ref5$reason === void 0 ? 'user' : _ref5$reason;

      this.emit('cancel-all', {
        reason: reason
      }); // Only remove existing uploads if user is canceling

      if (reason === 'user') {
        var _this$getState5 = this.getState(),
            files = _this$getState5.files;

        var fileIDs = Object.keys(files);

        if (fileIDs.length) {
          this.removeFiles(fileIDs, 'cancel-all');
        }

        this.setState({
          totalProgress: 0,
          error: null,
          recoveredState: null
        });
      }
    }
  }, {
    key: "retryUpload",
    value: function retryUpload(fileID) {
      this.setFileState(fileID, {
        error: null,
        isPaused: false
      });
      this.emit('upload-retry', fileID);

      var uploadID = _classPrivateFieldLooseBase(this, _createUpload)[_createUpload]([fileID], {
        forceAllowNewUpload: true // create new upload even if allowNewUpload: false

      });

      return _classPrivateFieldLooseBase(this, _runUpload)[_runUpload](uploadID);
    }
  }, {
    key: "logout",
    value: function logout() {
      this.iteratePlugins(function (plugin) {
        if (plugin.provider && plugin.provider.logout) {
          plugin.provider.logout();
        }
      });
    }
  }, {
    key: "calculateProgress",
    value: function calculateProgress(file, data) {
      if (file == null || !this.getFile(file.id)) {
        this.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));
        return;
      } // bytesTotal may be null or zero; in that case we can't divide by it


      var canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
      this.setFileState(file.id, {
        progress: _objectSpread(_objectSpread({}, this.getFile(file.id).progress), {}, {
          bytesUploaded: data.bytesUploaded,
          bytesTotal: data.bytesTotal,
          percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
        })
      });
      this.calculateTotalProgress();
    }
  }, {
    key: "calculateTotalProgress",
    value: function calculateTotalProgress() {
      // calculate total progress, using the number of files currently uploading,
      // multiplied by 100 and the summ of individual progress of each file
      var files = this.getFiles();
      var inProgress = files.filter(function (file) {
        return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
      });

      if (inProgress.length === 0) {
        this.emit('progress', 0);
        this.setState({
          totalProgress: 0
        });
        return;
      }

      var sizedFiles = inProgress.filter(function (file) {
        return file.progress.bytesTotal != null;
      });
      var unsizedFiles = inProgress.filter(function (file) {
        return file.progress.bytesTotal == null;
      });

      if (sizedFiles.length === 0) {
        var progressMax = inProgress.length * 100;
        var currentProgress = unsizedFiles.reduce(function (acc, file) {
          return acc + file.progress.percentage;
        }, 0);

        var _totalProgress = Math.round(currentProgress / progressMax * 100);

        this.setState({
          totalProgress: _totalProgress
        });
        return;
      }

      var totalSize = sizedFiles.reduce(function (acc, file) {
        return acc + file.progress.bytesTotal;
      }, 0);
      var averageSize = totalSize / sizedFiles.length;
      totalSize += averageSize * unsizedFiles.length;
      var uploadedSize = 0;
      sizedFiles.forEach(function (file) {
        uploadedSize += file.progress.bytesUploaded;
      });
      unsizedFiles.forEach(function (file) {
        uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
      });
      var totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100); // hot fix, because:
      // uploadedSize ended up larger than totalSize, resulting in 1325% total

      if (totalProgress > 100) {
        totalProgress = 100;
      }

      this.setState({
        totalProgress: totalProgress
      });
      this.emit('progress', totalProgress);
    }
    /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */

  }, {
    key: "updateOnlineStatus",
    value: function updateOnlineStatus() {
      var online = typeof window.navigator.onLine !== 'undefined' ? window.navigator.onLine : true;

      if (!online) {
        this.emit('is-offline');
        this.info(this.i18n('noInternetConnection'), 'error', 0);
        this.wasOffline = true;
      } else {
        this.emit('is-online');

        if (this.wasOffline) {
          this.emit('back-online');
          this.info(this.i18n('connectedToInternet'), 'success', 3000);
          this.wasOffline = false;
        }
      }
    }
  }, {
    key: "getID",
    value: function getID() {
      return this.opts.id;
    }
    /**
     * Registers a plugin with Core.
     *
     * @param {object} Plugin object
     * @param {object} [opts] object with options to be passed to Plugin
     * @returns {object} self for chaining
     */
    // eslint-disable-next-line no-shadow

  }, {
    key: "use",
    value: function use(Plugin, opts) {
      if (typeof Plugin !== 'function') {
        var msg = "Expected a plugin class, but got ".concat(Plugin === null ? 'null' : _typeof(Plugin), ".") + ' Please verify that the plugin was imported and spelled correctly.';
        throw new TypeError(msg);
      } // Instantiate


      var plugin = new Plugin(this, opts);
      var pluginId = plugin.id;

      if (!pluginId) {
        throw new Error('Your plugin must have an id');
      }

      if (!plugin.type) {
        throw new Error('Your plugin must have a type');
      }

      var existsPluginAlready = this.getPlugin(pluginId);

      if (existsPluginAlready) {
        var _msg = "Already found a plugin named '".concat(existsPluginAlready.id, "'. ") + "Tried to use: '".concat(pluginId, "'.\n") + 'Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.';

        throw new Error(_msg);
      }

      if (Plugin.VERSION) {
        this.log("Using ".concat(pluginId, " v").concat(Plugin.VERSION));
      }

      if (plugin.type in _classPrivateFieldLooseBase(this, _plugins)[_plugins]) {
        _classPrivateFieldLooseBase(this, _plugins)[_plugins][plugin.type].push(plugin);
      } else {
        _classPrivateFieldLooseBase(this, _plugins)[_plugins][plugin.type] = [plugin];
      }

      plugin.install();
      return this;
    }
    /**
     * Find one Plugin by name.
     *
     * @param {string} id plugin id
     * @returns {BasePlugin|undefined}
     */

  }, {
    key: "getPlugin",
    value: function getPlugin(id) {
      for (var _i2 = 0, _Object$values = Object.values(_classPrivateFieldLooseBase(this, _plugins)[_plugins]); _i2 < _Object$values.length; _i2++) {
        var plugins = _Object$values[_i2];
        var foundPlugin = plugins.find(function (plugin) {
          return plugin.id === id;
        });
        if (foundPlugin != null) return foundPlugin;
      }

      return undefined;
    }
  }, {
    key: _Symbol$for3,
    value: function value(type) {
      return _classPrivateFieldLooseBase(this, _plugins)[_plugins][type];
    }
    /**
     * Iterate through all `use`d plugins.
     *
     * @param {Function} method that will be run on each plugin
     */

  }, {
    key: "iteratePlugins",
    value: function iteratePlugins(method) {
      Object.values(_classPrivateFieldLooseBase(this, _plugins)[_plugins]).flat(1).forEach(method);
    }
    /**
     * Uninstall and remove a plugin.
     *
     * @param {object} instance The plugin instance to remove.
     */

  }, {
    key: "removePlugin",
    value: function removePlugin(instance) {
      this.log("Removing plugin ".concat(instance.id));
      this.emit('plugin-remove', instance);

      if (instance.uninstall) {
        instance.uninstall();
      }

      var list = _classPrivateFieldLooseBase(this, _plugins)[_plugins][instance.type]; // list.indexOf failed here, because Vue3 converted the plugin instance
      // to a Proxy object, which failed the strict comparison test:
      // obj !== objProxy


      var index = list.findIndex(function (item) {
        return item.id === instance.id;
      });

      if (index !== -1) {
        list.splice(index, 1);
      }

      var state = this.getState();
      var updatedState = {
        plugins: _objectSpread(_objectSpread({}, state.plugins), {}, _defineProperty({}, instance.id, undefined))
      };
      this.setState(updatedState);
    }
    /**
     * Uninstall all plugins and close down this Uppy instance.
     */

  }, {
    key: "close",
    value: function close(_temp2) {
      var _this5 = this;

      var _ref6 = _temp2 === void 0 ? {} : _temp2,
          reason = _ref6.reason;

      this.log("Closing Uppy instance ".concat(this.opts.id, ": removing all files and uninstalling plugins"));
      this.cancelAll({
        reason: reason
      });

      _classPrivateFieldLooseBase(this, _storeUnsubscribe)[_storeUnsubscribe]();

      this.iteratePlugins(function (plugin) {
        _this5.removePlugin(plugin);
      });

      if (typeof window !== 'undefined' && window.removeEventListener) {
        window.removeEventListener('online', _classPrivateFieldLooseBase(this, _updateOnlineStatus)[_updateOnlineStatus]);
        window.removeEventListener('offline', _classPrivateFieldLooseBase(this, _updateOnlineStatus)[_updateOnlineStatus]);
      }
    }
  }, {
    key: "hideInfo",
    value: function hideInfo() {
      var _this$getState6 = this.getState(),
          info = _this$getState6.info;

      this.setState({
        info: info.slice(1)
      });
      this.emit('info-hidden');
    }
    /**
     * Set info message in `state.info`, so that UI plugins like `Informer`
     * can display the message.
     *
     * @param {string | object} message Message to be displayed by the informer
     * @param {string} [type]
     * @param {number} [duration]
     */

  }, {
    key: "info",
    value: function info(message, type, duration) {
      var _this6 = this;

      if (type === void 0) {
        type = 'info';
      }

      if (duration === void 0) {
        duration = 3000;
      }

      var isComplexMessage = _typeof(message) === 'object';
      this.setState({
        info: [].concat(_toConsumableArray(this.getState().info), [{
          type: type,
          message: isComplexMessage ? message.message : message,
          details: isComplexMessage ? message.details : null
        }])
      });
      setTimeout(function () {
        return _this6.hideInfo();
      }, duration);
      this.emit('info-visible');
    }
    /**
     * Passes messages to a function, provided in `opts.logger`.
     * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
     *
     * @param {string|object} message to log
     * @param {string} [type] optional `error` or `warning`
     */

  }, {
    key: "log",
    value: function log(message, type) {
      var logger = this.opts.logger;

      switch (type) {
        case 'error':
          logger.error(message);
          break;

        case 'warning':
          logger.warn(message);
          break;

        default:
          logger.debug(message);
          break;
      }
    }
    /**
     * Restore an upload by its ID.
     */

  }, {
    key: "restore",
    value: function restore(uploadID) {
      this.log("Core: attempting to restore upload \"".concat(uploadID, "\""));

      if (!this.getState().currentUploads[uploadID]) {
        _classPrivateFieldLooseBase(this, _removeUpload)[_removeUpload](uploadID);

        return Promise.reject(new Error('Nonexistent upload'));
      }

      return _classPrivateFieldLooseBase(this, _runUpload)[_runUpload](uploadID);
    }
    /**
     * Create an upload for a bunch of files.
     *
     * @param {Array<string>} fileIDs File IDs to include in this upload.
     * @returns {string} ID of this upload.
     */

  }, {
    key: _Symbol$for4,
    value: function value() {
      var _classPrivateFieldLoo5;

      return (_classPrivateFieldLoo5 = _classPrivateFieldLooseBase(this, _createUpload))[_createUpload].apply(_classPrivateFieldLoo5, arguments);
    }
    /**
     * Add data to an upload's result object.
     *
     * @param {string} uploadID The ID of the upload.
     * @param {object} data Data properties to add to the result object.
     */

  }, {
    key: "addResultData",
    value: function addResultData(uploadID, data) {
      if (!_classPrivateFieldLooseBase(this, _getUpload)[_getUpload](uploadID)) {
        this.log("Not setting result for an upload that has been removed: ".concat(uploadID));
        return;
      }

      var _this$getState7 = this.getState(),
          currentUploads = _this$getState7.currentUploads;

      var currentUpload = _objectSpread(_objectSpread({}, currentUploads[uploadID]), {}, {
        result: _objectSpread(_objectSpread({}, currentUploads[uploadID].result), data)
      });

      this.setState({
        currentUploads: _objectSpread(_objectSpread({}, currentUploads), {}, _defineProperty({}, uploadID, currentUpload))
      });
    }
    /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     * @param {string} uploadID The ID of the upload.
     */

    /**
     * Start an upload for all the files that are not currently being uploaded.
     *
     * @returns {Promise}
     */

  }, {
    key: "upload",
    value: function upload() {
      var _this7 = this;

      var _classPrivateFieldLoo;

      if (!((_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _plugins)[_plugins].uploader) != null && _classPrivateFieldLoo.length)) {
        this.log('No uploader type plugins are used', 'warning');
      }

      var _this$getState8 = this.getState(),
          files = _this$getState8.files;

      var onBeforeUploadResult = this.opts.onBeforeUpload(files);

      if (onBeforeUploadResult === false) {
        return Promise.reject(new Error('Not starting the upload because onBeforeUpload returned false'));
      }

      if (onBeforeUploadResult && _typeof(onBeforeUploadResult) === 'object') {
        files = onBeforeUploadResult; // Updating files in state, because uploader plugins receive file IDs,
        // and then fetch the actual file object from state

        this.setState({
          files: files
        });
      }

      return Promise.resolve().then(function () {
        return _classPrivateFieldLooseBase(_this7, _restricter)[_restricter].validateMinNumberOfFiles(files);
      }).catch(function (err) {
        _classPrivateFieldLooseBase(_this7, _informAndEmit)[_informAndEmit]([err]);

        throw err;
      }).then(function () {
        if (!_classPrivateFieldLooseBase(_this7, _checkRequiredMetaFields)[_checkRequiredMetaFields](files)) {
          throw new RestrictionError(_this7.i18n('missingRequiredMetaField'));
        }
      }).catch(function (err) {
        // Doing this in a separate catch because we already emited and logged
        // all the errors in `checkRequiredMetaFields` so we only throw a generic
        // missing fields error here.
        throw err;
      }).then(function () {
        var _this7$getState = _this7.getState(),
            currentUploads = _this7$getState.currentUploads; // get a list of files that are currently assigned to uploads


        var currentlyUploadingFiles = Object.values(currentUploads).flatMap(function (curr) {
          return curr.fileIDs;
        });
        var waitingFileIDs = [];
        Object.keys(files).forEach(function (fileID) {
          var file = _this7.getFile(fileID); // if the file hasn't started uploading and hasn't already been assigned to an upload..


          if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) {
            waitingFileIDs.push(file.id);
          }
        });

        var uploadID = _classPrivateFieldLooseBase(_this7, _createUpload)[_createUpload](waitingFileIDs);

        return _classPrivateFieldLooseBase(_this7, _runUpload)[_runUpload](uploadID);
      }).catch(function (err) {
        _this7.emit('error', err);

        _this7.log(err, 'error');

        throw err;
      });
    }
  }]);

  return Uppy;
}(_Symbol$for, _Symbol$for2);

function _informAndEmit2(errors) {
  var _this8 = this;

  var _iterator = _createForOfIteratorHelper(errors),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var error = _step.value;
      var file = error.file,
          isRestriction = error.isRestriction;

      if (isRestriction) {
        this.emit('restriction-failed', file, error);
      } else {
        this.emit('error', error);
      }

      this.log(error, 'warning');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var userFacingErrors = errors.filter(function (error) {
    return error.isUserFacing;
  }); // don't flood the user: only show the first 4 toasts

  var maxNumToShow = 4;
  var firstErrors = userFacingErrors.slice(0, maxNumToShow);
  var additionalErrors = userFacingErrors.slice(maxNumToShow);
  firstErrors.forEach(function (_ref3) {
    var message = _ref3.message,
        _ref3$details = _ref3.details,
        details = _ref3$details === void 0 ? '' : _ref3$details;

    _this8.info({
      message: message,
      details: details
    }, 'error', _this8.opts.infoTimeout);
  });

  if (additionalErrors.length > 0) {
    this.info({
      message: this.i18n('additionalRestrictionsFailed', {
        count: additionalErrors.length
      })
    });
  }
}

function _checkRequiredMetaFieldsOnFile2(file) {
  var _classPrivateFieldLoo6 = _classPrivateFieldLooseBase(this, _restricter)[_restricter].getMissingRequiredMetaFields(file),
      missingFields = _classPrivateFieldLoo6.missingFields,
      error = _classPrivateFieldLoo6.error;

  if (missingFields.length > 0) {
    this.setFileState(file.id, {
      missingRequiredMetaFields: missingFields
    });
    this.log(error.message);
    this.emit('restriction-failed', file, error);
    return false;
  }

  return true;
}

function _checkRequiredMetaFields2(files) {
  var success = true;

  for (var _i3 = 0, _Object$values2 = Object.values(files); _i3 < _Object$values2.length; _i3++) {
    var file = _Object$values2[_i3];

    if (!_classPrivateFieldLooseBase(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file)) {
      success = false;
    }
  }

  return success;
}

function _assertNewUploadAllowed2(file) {
  var _this$getState9 = this.getState(),
      allowNewUpload = _this$getState9.allowNewUpload;

  if (allowNewUpload === false) {
    var error = new RestrictionError(this.i18n('noMoreFilesAllowed'), {
      file: file
    });

    _classPrivateFieldLooseBase(this, _informAndEmit)[_informAndEmit]([error]);

    throw error;
  }
}

function _transformFile2(fileDescriptorOrFile) {
  // Uppy expects files in { name, type, size, data } format.
  // If the actual File object is passed from input[type=file] or drag-drop,
  // we normalize it to match Uppy file object
  var fileDescriptor = fileDescriptorOrFile instanceof File ? {
    name: fileDescriptorOrFile.name,
    type: fileDescriptorOrFile.type,
    size: fileDescriptorOrFile.size,
    data: fileDescriptorOrFile
  } : fileDescriptorOrFile;
  var fileType = getFileType(fileDescriptor);
  var fileName = getFileName(fileType, fileDescriptor);
  var fileExtension = getFileNameAndExtension(fileName).extension;
  var isRemote = Boolean(fileDescriptor.isRemote);
  var id = getSafeFileId(fileDescriptor);
  var meta = fileDescriptor.meta || {};
  meta.name = fileName;
  meta.type = fileType; // `null` means the size is unknown.

  var size = Number.isFinite(fileDescriptor.data.size) ? fileDescriptor.data.size : null;
  return {
    source: fileDescriptor.source || '',
    id: id,
    name: fileName,
    extension: fileExtension || '',
    meta: _objectSpread(_objectSpread({}, this.getState().meta), meta),
    type: fileType,
    data: fileDescriptor.data,
    progress: {
      percentage: 0,
      bytesUploaded: 0,
      bytesTotal: size,
      uploadComplete: false,
      uploadStarted: null
    },
    size: size,
    isRemote: isRemote,
    remote: fileDescriptor.remote || '',
    preview: fileDescriptor.preview
  };
}

function _startIfAutoProceed2() {
  var _this9 = this;

  if (this.opts.autoProceed && !this.scheduledAutoProceed) {
    this.scheduledAutoProceed = setTimeout(function () {
      _this9.scheduledAutoProceed = null;

      _this9.upload().catch(function (err) {
        if (!err.isRestriction) {
          _this9.log(err.stack || err.message || err);
        }
      });
    }, 4);
  }
}

function _checkAndUpdateFileState2(filesToAdd) {
  var _this$getState10 = this.getState(),
      existingFiles = _this$getState10.files; // create a copy of the files object only once


  var nextFilesState = _objectSpread({}, existingFiles);

  var validFilesToAdd = [];
  var errors = [];

  var _iterator2 = _createForOfIteratorHelper(filesToAdd),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var fileToAdd = _step2.value;

      try {
        var _existingFiles$newFil;

        var newFile = _classPrivateFieldLooseBase(this, _transformFile)[_transformFile](fileToAdd); // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everthing else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now


        if ((_existingFiles$newFil = existingFiles[newFile.id]) != null && _existingFiles$newFil.isGhost) {
          var _existingFiles$newFil2 = existingFiles[newFile.id],
              isGhost = _existingFiles$newFil2.isGhost,
              existingFileState = _objectWithoutProperties(_existingFiles$newFil2, _excluded);

          newFile = _objectSpread(_objectSpread({}, existingFileState), {}, {
            data: fileToAdd.data
          });
          this.log("Replaced the blob in the restored ghost file: ".concat(newFile.name, ", ").concat(newFile.id));
        }

        if (this.checkIfFileAlreadyExists(newFile.id)) {
          throw new RestrictionError(this.i18n('noDuplicates', {
            fileName: newFile.name
          }), {
            file: fileToAdd
          });
        }

        var onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);

        if (onBeforeFileAddedResult === false) {
          // Don’t show UI info for this error, as it should be done by the developer
          throw new RestrictionError('Cannot add the file because onBeforeFileAdded returned false.', {
            isUserFacing: false,
            file: fileToAdd
          });
        } else if (_typeof(onBeforeFileAddedResult) === 'object' && onBeforeFileAddedResult !== null) {
          newFile = onBeforeFileAddedResult;
        }

        _classPrivateFieldLooseBase(this, _restricter)[_restricter].validateSingleFile(newFile); // need to add it to the new local state immediately, so we can use the state to validate the next files too


        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
      } catch (err) {
        errors.push(err);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  try {
    // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
    // when many files are added
    _classPrivateFieldLooseBase(this, _restricter)[_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
  } catch (err) {
    errors.push(err); // If we have any aggregate error, don't allow adding this batch

    return {
      nextFilesState: existingFiles,
      validFilesToAdd: [],
      errors: errors
    };
  }

  return {
    nextFilesState: nextFilesState,
    validFilesToAdd: validFilesToAdd,
    errors: errors
  };
}

function _addListeners2() {
  var _this10 = this;

  /**
   * @param {Error} error
   * @param {object} [file]
   * @param {object} [response]
   */
  var errorHandler = function errorHandler(error, file, response) {
    var errorMsg = error.message || 'Unknown error';

    if (error.details) {
      errorMsg += " ".concat(error.details);
    }

    _this10.setState({
      error: errorMsg
    });

    if (file != null && file.id in _this10.getState().files) {
      _this10.setFileState(file.id, {
        error: errorMsg,
        response: response
      });
    }
  };

  this.on('error', errorHandler);
  this.on('upload-error', function (file, error, response) {
    errorHandler(error, file, response);

    if (_typeof(error) === 'object' && error.message) {
      var newError = new Error(error.message);
      newError.isUserFacing = true; // todo maybe don't do this with all errors?

      newError.details = error.message;

      if (error.details) {
        newError.details += " ".concat(error.details);
      }

      newError.message = _this10.i18n('failedToUpload', {
        file: file == null ? void 0 : file.name
      });

      _classPrivateFieldLooseBase(_this10, _informAndEmit)[_informAndEmit]([newError]);
    } else {
      _classPrivateFieldLooseBase(_this10, _informAndEmit)[_informAndEmit]([error]);
    }
  });
  var uploadStalledWarningRecentlyEmitted;
  this.on('upload-stalled', function (error, files) {
    var message = error.message;
    var details = files.map(function (file) {
      return file.meta.name;
    }).join(', ');

    if (!uploadStalledWarningRecentlyEmitted) {
      _this10.info({
        message: message,
        details: details
      }, 'warning', _this10.opts.infoTimeout);

      uploadStalledWarningRecentlyEmitted = setTimeout(function () {
        uploadStalledWarningRecentlyEmitted = null;
      }, _this10.opts.infoTimeout);
    }

    _this10.log("".concat(message, " ").concat(details).trim(), 'warning');
  });
  this.on('upload', function () {
    _this10.setState({
      error: null
    });
  });

  var onUploadStarted = function onUploadStarted(files) {
    var filesFiltered = files.filter(function (file) {
      var exists = file != null && _this10.getFile(file.id);

      if (!exists) _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));
      return exists;
    });
    var filesState = Object.fromEntries(filesFiltered.map(function (file) {
      return [file.id, {
        progress: {
          uploadStarted: Date.now(),
          uploadComplete: false,
          percentage: 0,
          bytesUploaded: 0,
          bytesTotal: file.size
        }
      }];
    }));

    _this10.patchFilesState(filesState);
  };

  this.on('upload-start', function (files) {
    files.forEach(function (file) {
      // todo backward compat, remove this event in a next major
      _this10.emit('upload-started', file);
    });
    onUploadStarted(files);
  });
  this.on('upload-progress', this.calculateProgress);
  this.on('upload-success', function (file, uploadResp) {
    if (file == null || !_this10.getFile(file.id)) {
      _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));

      return;
    }

    var currentProgress = _this10.getFile(file.id).progress;

    _this10.setFileState(file.id, {
      progress: _objectSpread(_objectSpread({}, currentProgress), {}, {
        postprocess: _classPrivateFieldLooseBase(_this10, _postProcessors)[_postProcessors].size > 0 ? {
          mode: 'indeterminate'
        } : null,
        uploadComplete: true,
        percentage: 100,
        bytesUploaded: currentProgress.bytesTotal
      }),
      response: uploadResp,
      uploadURL: uploadResp.uploadURL,
      isPaused: false
    }); // Remote providers sometimes don't tell us the file size,
    // but we can know how many bytes we uploaded once the upload is complete.


    if (file.size == null) {
      _this10.setFileState(file.id, {
        size: uploadResp.bytesUploaded || currentProgress.bytesTotal
      });
    }

    _this10.calculateTotalProgress();
  });
  this.on('preprocess-progress', function (file, progress) {
    if (file == null || !_this10.getFile(file.id)) {
      _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));

      return;
    }

    _this10.setFileState(file.id, {
      progress: _objectSpread(_objectSpread({}, _this10.getFile(file.id).progress), {}, {
        preprocess: progress
      })
    });
  });
  this.on('preprocess-complete', function (file) {
    if (file == null || !_this10.getFile(file.id)) {
      _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));

      return;
    }

    var files = _objectSpread({}, _this10.getState().files);

    files[file.id] = _objectSpread(_objectSpread({}, files[file.id]), {}, {
      progress: _objectSpread({}, files[file.id].progress)
    });
    delete files[file.id].progress.preprocess;

    _this10.setState({
      files: files
    });
  });
  this.on('postprocess-progress', function (file, progress) {
    if (file == null || !_this10.getFile(file.id)) {
      _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));

      return;
    }

    _this10.setFileState(file.id, {
      progress: _objectSpread(_objectSpread({}, _this10.getState().files[file.id].progress), {}, {
        postprocess: progress
      })
    });
  });
  this.on('postprocess-complete', function (file) {
    if (file == null || !_this10.getFile(file.id)) {
      _this10.log("Not setting progress for a file that has been removed: ".concat(file == null ? void 0 : file.id));

      return;
    }

    var files = _objectSpread({}, _this10.getState().files);

    files[file.id] = _objectSpread(_objectSpread({}, files[file.id]), {}, {
      progress: _objectSpread({}, files[file.id].progress)
    });
    delete files[file.id].progress.postprocess;

    _this10.setState({
      files: files
    });
  });
  this.on('restored', function () {
    // Files may have changed--ensure progress is still accurate.
    _this10.calculateTotalProgress();
  });
  this.on('dashboard:file-edit-complete', function (file) {
    if (file) {
      _classPrivateFieldLooseBase(_this10, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
    }
  }); // show informer if offline

  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('online', _classPrivateFieldLooseBase(this, _updateOnlineStatus)[_updateOnlineStatus]);
    window.addEventListener('offline', _classPrivateFieldLooseBase(this, _updateOnlineStatus)[_updateOnlineStatus]);
    setTimeout(_classPrivateFieldLooseBase(this, _updateOnlineStatus)[_updateOnlineStatus], 3000);
  }
}

function _createUpload2(fileIDs, opts) {
  if (opts === void 0) {
    opts = {};
  } // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`


  var _opts2 = opts,
      _opts2$forceAllowNewU = _opts2.forceAllowNewUpload,
      forceAllowNewUpload = _opts2$forceAllowNewU === void 0 ? false : _opts2$forceAllowNewU;

  var _this$getState11 = this.getState(),
      allowNewUpload = _this$getState11.allowNewUpload,
      currentUploads = _this$getState11.currentUploads;

  if (!allowNewUpload && !forceAllowNewUpload) {
    throw new Error('Cannot create a new upload: already uploading.');
  }

  var uploadID = nanoid();
  this.emit('upload', {
    id: uploadID,
    fileIDs: fileIDs
  });
  this.setState({
    allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
    currentUploads: _objectSpread(_objectSpread({}, currentUploads), {}, _defineProperty({}, uploadID, {
      fileIDs: fileIDs,
      step: 0,
      result: {}
    }))
  });
  return uploadID;
}

function _getUpload2(uploadID) {
  var _this$getState12 = this.getState(),
      currentUploads = _this$getState12.currentUploads;

  return currentUploads[uploadID];
}

function _removeUpload2(uploadID) {
  var currentUploads = _objectSpread({}, this.getState().currentUploads);

  delete currentUploads[uploadID];
  this.setState({
    currentUploads: currentUploads
  });
}

function _runUpload2(_x) {
  return _runUpload3.apply(this, arguments);
}

function _runUpload3() {
  _runUpload3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uploadID) {
    var _this11 = this;

    var getCurrentUpload, currentUpload, steps, step, fn, _currentUpload, fileIDs, files, successful, failed, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getCurrentUpload = function getCurrentUpload() {
              var _this11$getState = _this11.getState(),
                  currentUploads = _this11$getState.currentUploads;

              return currentUploads[uploadID];
            };

            currentUpload = getCurrentUpload();
            steps = [].concat(_toConsumableArray(_classPrivateFieldLooseBase(this, _preProcessors)[_preProcessors]), _toConsumableArray(_classPrivateFieldLooseBase(this, _uploaders)[_uploaders]), _toConsumableArray(_classPrivateFieldLooseBase(this, _postProcessors)[_postProcessors]));
            _context.prev = 3;
            step = currentUpload.step || 0;

          case 5:
            if (!(step < steps.length)) {
              _context.next = 17;
              break;
            }

            if (currentUpload) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("break", 17);

          case 8:
            fn = steps[step];
            this.setState({
              currentUploads: _objectSpread(_objectSpread({}, this.getState().currentUploads), {}, _defineProperty({}, uploadID, _objectSpread(_objectSpread({}, currentUpload), {}, {
                step: step
              })))
            });
            _currentUpload = currentUpload, fileIDs = _currentUpload.fileIDs; // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters

            _context.next = 13;
            return fn(fileIDs, uploadID);

          case 13:
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();

          case 14:
            step++;
            _context.next = 5;
            break;

          case 17:
            _context.next = 23;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](3);

            _classPrivateFieldLooseBase(this, _removeUpload)[_removeUpload](uploadID);

            throw _context.t0;

          case 23:
            if (!currentUpload) {
              _context.next = 31;
              break;
            }

            // Mark postprocessing step as complete if necessary; this addresses a case where we might get
            // stuck in the postprocessing UI while the upload is fully complete.
            // If the postprocessing steps do not do any work, they may not emit postprocessing events at
            // all, and never mark the postprocessing as complete. This is fine on its own but we
            // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
            // state if any postprocessors are registered. That is to avoid a "flash of completed state"
            // before the postprocessing plugins can emit events.
            //
            // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
            // postprocessing completion, we do it instead.
            currentUpload.fileIDs.forEach(function (fileID) {
              var file = _this11.getFile(fileID);

              if (file && file.progress.postprocess) {
                _this11.emit('postprocess-complete', file);
              }
            });
            files = currentUpload.fileIDs.map(function (fileID) {
              return _this11.getFile(fileID);
            });
            successful = files.filter(function (file) {
              return !file.error;
            });
            failed = files.filter(function (file) {
              return file.error;
            });
            _context.next = 30;
            return this.addResultData(uploadID, {
              successful: successful,
              failed: failed,
              uploadID: uploadID
            });

          case 30:
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();

          case 31:
            if (currentUpload) {
              result = currentUpload.result;
              this.emit('complete', result);

              _classPrivateFieldLooseBase(this, _removeUpload)[_removeUpload](uploadID);
            }

            if (result == null) {
              this.log("Not setting result for an upload that has been removed: ".concat(uploadID));
            }

            return _context.abrupt("return", result);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 19]]);
  }));
  return _runUpload3.apply(this, arguments);
}

Uppy.VERSION = packageJson.version;
export default Uppy;